import { useTranslation } from 'react-i18next';
import './ButtonsStyle.css';

export const CancelButton = ({ onClick }) => {
    const { t } = useTranslation();
    return (
        <button className={'button--main warning-button'} onClick={onClick} type={'button'}>
            {t('common:buttons.cancel')}
        </button>
    );
};
